export const getConfiguredAccountRuntime = () => {
  // Keep the build-time check literal so guest bundles omit the account runtime.
  if (process.env.REACT_APP_PUBLIC_GUEST_MODE === "true") return null;
  return require("./accountRepositoryRuntime").getAccountRepositoryRuntime();
};
